// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
export type OrganizationFeaturesFragment = {
  __typename?: "EnabledFeatures";
  id: string;
  indexCheck: boolean;
  checkUp: boolean;
  schemaStats: boolean;
  logs: boolean;
  activitySnapshots: boolean;
  saml: boolean;
  indexAdvisor: boolean;
  indexAdvisorV3Consolidation: boolean;
  lockMonitoring: boolean;
  querySearch: boolean;
  workbooks: boolean;
  queryAdvisor: boolean;
  hideWebsocketWarning: boolean;
  mcpServer: boolean;
};

export const OrganizationFeaturesFragmentDoc = gql`
  fragment OrganizationFeatures on EnabledFeatures {
    id
    indexCheck
    checkUp
    schemaStats
    logs
    activitySnapshots
    saml
    indexAdvisor
    indexAdvisorV3Consolidation
    lockMonitoring
    querySearch
    workbooks
    queryAdvisor
    hideWebsocketWarning
    mcpServer
  }
`;
